import { render, staticRenderFns } from "./EmailCrud.vue?vue&type=template&id=fc8ec93c"
import script from "./EmailCrud.vue?vue&type=script&lang=js"
export * from "./EmailCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports